import React from 'react';
import style from '../css/Travel.module.css';
import womanImage from '../assets/images/tra.png';

function Travel() {
	return (
		<div className={style.container}>
			<div className={style.textSection}>
				<h2>See where Exporest will take your company</h2>
				<button className={style.button}>Get started</button>
			</div>
			<div className={style.imageSection}>
				<img src={womanImage} alt="Traveler" className={style.image} />
			</div>
		</div>
	);
}

export default Travel;
